import { getLocalStorageValue, setLocalStorageValue } from "../common/helpers/localStorageHelper";

export type PrintType = "cashQR" | "receipt";

export interface IPrintHistoryEntry {
	/** Unique id for React keys and per-row reprint state. */
	id: string;
	/** Epoch milliseconds when the print was recorded. */
	timestamp: number;
	/** Payable total in cents, displayed via displayCentsWithDollarSign. */
	amountCents: number;
	type: PrintType;
	/** The exact string[] originally passed to submitPrint — replayed on reprint. */
	payload: string[];
}

export const PRINT_HISTORY_KEY = "sok_print_history";
export const MAX_PRINT_HISTORY = 10;

export const getPrintHistory = (): IPrintHistoryEntry[] =>
	getLocalStorageValue<IPrintHistoryEntry[]>(PRINT_HISTORY_KEY, []);

/**
 * Record a successful print so it can be reprinted later from the
 * Maintenance page. Keeps only the MAX_PRINT_HISTORY most recent prints,
 * newest first. Persisted to localStorage so it survives an app reload
 * (the recovery path after a paper jam).
 */
export const recordPrint = (entry: {
	amountCents: number;
	type: PrintType;
	payload: string[];
}): void => {
	const newEntry: IPrintHistoryEntry = {
		id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
		timestamp: Date.now(),
		amountCents: entry.amountCents,
		type: entry.type,
		payload: entry.payload,
	};

	const next = [newEntry, ...getPrintHistory()].slice(0, MAX_PRINT_HISTORY);

	setLocalStorageValue(PRINT_HISTORY_KEY, next);
};
